import "../chunk-PKUHTIDK.js";
import { handleClick, clearTimer } from "./index";
const api = ["state", "handleClick"];
const renderless = (props, { computed, onBeforeUnmount, reactive, watch, inject }, { emit, parent }) => {
  parent.tinyForm = parent.tinyForm || inject("form", null);
  const state = reactive({
    timer: void 0,
    disabled: props.disabled,
    plain: computed(() => props.plain || (parent.buttonGroup || {}).plain),
    formDisabled: computed(() => (parent.tinyForm || {}).disabled),
    buttonDisabled: computed(
      () => props.disabled || state.disabled || (parent.buttonGroup || {}).disabled || state.formDisabled
    )
  });
  watch(
    () => props.disabled,
    (value) => {
      state.disabled = value;
    },
    { immediate: true }
  );
  const api2 = {
    state,
    clearTimer: clearTimer(state),
    handleClick: handleClick({ emit, props, state })
  };
  onBeforeUnmount(api2.clearTimer);
  return api2;
};
export {
  api,
  renderless
};
